module.exports = __webpack_public_path__ + "static/media/jestjs.2c3c135c.svg";